import React, { useEffect, useRef, useState } from "react";
import TableHeader from "containers/gstr2a2bNewEnhancement/Utility/TableHeader";
import { useDispatch, useSelector } from "react-redux";
import { availedList, baseDataList, DocViewHeaders } from "../../constants";
import Matched from "./Matched/Matched";
import ProbableMatch from "./ProbableMatch/ProbableMatch";
import MisMatch from "./MisMatch/MisMatch";
import NotInGSTN from "./NotInGSTN/NotInGSTN";
import NotInPR from "./NotInPR/NotInPR";
import Rejected from "./Rejected/Rejected";
import {
  downloadExcelDocView,
  getReset,
  setActiveTabDocView,
  setInumFilter,
  setMonth3bFilter,
  setMonthFilter,
  setRgstinTaxpayerFilter,
  setSearchStr,
  setSgstinTaxpayerFilter,
  setBaseDataFilter,
  setAvailedFilter,
  getPending,
  getDeLink,
  getReject,
  getRecoFilterList,
  getRecoTablesData,
  setPageNoMatched,
  setPageNoMismatch,
  setPageNoProbable,
  setPageNoNotInGstn,
  setPageNoNotInPr,
  setPageNoRejected,
  setSelectedProbable,
  setSelectedMismatch,
  setSelectedNotInPR,
  setSelectedNotInGstn,
  setSelectedRejected,
  getAcceptPrGstn,
  setSelectedRowMismatch,
  setSelectedRowProbable,
  setSelectedRowNotInGstn,
  setSelectedMatched,
  setSelectedRowMatched,
} from "../../action";
import MatchedFilter from "./MatchedFilter";
import NotMatchedFilter from "./NotMatchedFilter";
import Slide from "@material-ui/core/Slide";
import filterImage from "../../../../../images/filterImg.png";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { Button } from "@material-ui/core";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});
const DocView = () => {
  const dispatch = useDispatch();
  const {
    activeTabDocView,
    viewRecoTableData,
    selectedMatched,
    rgstinTaxpayerFilter,
    sgstinTaxpayerFilter,
    inumFilter,
    monthFilter,
    month3bFilter,
    baseDataFilter,
    availedFilter,
    activeTabReco,
    activeTabViewReco,
    dateRange,
    dateRangeFilter,
    selection,
    recoSelection,
    selectedYear,
    docViewTableData,
  } = useSelector((store) => store.gstr2a2bNewRecoReducer);
  const debounceTimeout = useRef(null);
  const { defaultEntity, selectedGstin } = useSelector(
    (store) => store.gstr2a2bNewCommonReducer
  );
  const [open, setOpen] = useState(false);

  // const [rgstinTaxpayerFilter, setRgstinTaxpayerFilter] = useState([]);
  const [recipientGstin, setRecipientGstin] = useState(null);
  // const [sgstinTaxpayerFilter, setSgstinTaxpayerFilter] = useState([]);
  const [supplierGstin, setSupplierGstin] = useState(null);
  // const [inumFilter, setInumFilter] = useState([]);
  const [inum, setInum] = useState(null);
  // const [monthFilter, setMonthFilter] = useState([]);
  const [month, setMonth] = useState(null);
  // const [month3bFilter, setMonth3bFilter] = useState([]);
  const [month3b, setMonth3b] = useState(null);
  // const [baseDataFilter, setBaseDataFilter] = useState([]);
  // const [availedFilter, setAvailedFilter] = useState([]);
  const [filterList, setFilterList] = useState([]);
  async function handleTabChange(id) {
    await dispatch(setActiveTabDocView(id));
  }

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    setOpen(false);
  };

  const handleOpen = async () => {
    try {
      if (
        defaultEntity &&
        selectedGstin?.length > 0 &&
        selection &&
        recoSelection &&
        selectedYear
      ) {
        const response = await dispatch(
          getRecoFilterList(
            selectedGstin,
            selection,
            recoSelection,
            selectedYear,
            dateRange,
            activeTabReco,
            activeTabViewReco,
            activeTabDocView
          )
        );
        console.log("response in filter list:", response);
        setFilterList(response);
        setOpen(true);
      } else {
        errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      }
    } catch (error) {
      console.error("Error in handleOpen:", error);
      errorToastMessage("Failed to open filter dialog.");
    }
  };
  async function handleClearFilter() {
    try {
      await dispatch(
        getRecoTablesData(
          selectedGstin,
          selection,
          recoSelection,
          selectedYear,
          dateRangeFilter,
          activeTabReco,
          activeTabViewReco,
          activeTabDocView,
          1,
          [],
          [],
          [],
          [],
          [],
          [],
          []
        )
      );
      dispatch(setRgstinTaxpayerFilter([]));
      dispatch(setSgstinTaxpayerFilter([]));
      dispatch(setInumFilter([]));
      dispatch(setMonthFilter([]));
      dispatch(setMonth3bFilter([]));
      dispatch(setBaseDataFilter([]));
      dispatch(setAvailedFilter([]));
      handleClose();
    } catch (error) {
      console.error("Error in handleClearFilter:", error);
      errorToastMessage("Failed to clear filters.");
    }
  }

  async function handleFilterApply() {
    handleSubmit(false, 1);
    handleClose();
  }
  function handleAddRecipientGstin() {
    if (recipientGstin != null) {
      let temp = [...rgstinTaxpayerFilter, recipientGstin];
      temp = [...new Set([...temp])];
      // setRgstinTaxpayerFilter(temp);
      dispatch(setRgstinTaxpayerFilter(temp));
      setRecipientGstin(null);
    }
  }
  function handleAddSupplierGstin() {
    if (supplierGstin != null) {
      let temp = [...sgstinTaxpayerFilter, supplierGstin];
      temp = [...new Set([...temp])];
      // setSgstinTaxpayerFilter(temp);
      dispatch(setSgstinTaxpayerFilter(temp));
      setSupplierGstin(null);
    }
  }
  function handleAddInum() {
    if (inum != null) {
      let temp = [...inumFilter, inum];
      temp = [...new Set([...temp])];
      // setInumFilter(temp);
      dispatch(setInumFilter(temp));
      setInum(null);
    }
  }
  function handleAddMonth() {
    if (month != null) {
      let temp = [...monthFilter, month];
      temp = [...new Set([...temp])];
      // setMonthFilter(temp);
      dispatch(setMonthFilter(temp));
      setMonth(null);
    }
  }
  function handleAddMonth3b() {
    if (month3b != null) {
      let temp = [...month3bFilter, month3b];
      temp = [...new Set([...temp])];
      // setMonth3bFilter(temp);
      dispatch(setMonth3bFilter(temp));
      setMonth3b(null);
    }
  }
  function handleChipDelete(index, type) {
    let temp;
    if (type === "rgstin") {
      temp = [...rgstinTaxpayerFilter];
      temp.splice(index, 1);
      // setRgstinTaxpayerFilter(temp);
      dispatch(setRgstinTaxpayerFilter(temp));
    } else if (type === "sgstin") {
      temp = [...sgstinTaxpayerFilter];
      temp.splice(index, 1);
      // setSgstinTaxpayerFilter(temp);
      dispatch(setSgstinTaxpayerFilter(temp));
    } else if (type === "Inum") {
      temp = [...inumFilter];
      temp.splice(index, 1);
      // setInumFilter(temp);
      dispatch(setInumFilter(temp));
    } else if (type === "month") {
      temp = [...monthFilter];
      temp.splice(index, 1);
      // setMonthFilter(temp);
      dispatch(setMonthFilter(temp));
    } else if (type === "month3b") {
      temp = [...month3bFilter];
      temp.splice(index, 1);
      // setMonth3bFilter(temp);
      dispatch(setMonth3bFilter(temp));
    } else console.log("error in filter");
  }
  const defaultPropsRecipientGstins = {
    options: filterList?.recipient_GSTIN,
    getOptionLabel: (option) => option,
  };
  const defaultPropsSupplierGstins = {
    options: filterList?.supplier_GSTIN,
    getOptionLabel: (option) => option,
  };
  const defaultPropsMonth = {
    options: filterList?.recipient_GSTIN,
    getOptionLabel: (option) => option,
  };
  const defaultPropsMonth3b = {
    options: filterList?.threeBMonth,
    getOptionLabel: (option) => option,
  };
  const defaultPropsInum = {
    options: filterList?.document_Number,
    getOptionLabel: (option) => option,
  };
  function onChangeRecipientGstin(newValue) {
    setRecipientGstin(newValue);
  }
  function onChangeSupplierGstin(newValue) {
    setSupplierGstin(newValue);
  }
  function onChangeInum(newValue) {
    setInum(newValue);
  }
  function onChangeMonth(newValue) {
    setMonth(newValue);
  }
  function onChangeMonth3b(newValue) {
    setMonth3b(newValue);
  }
  function handleBaseDataFilterChange(e) {
    dispatch(setBaseDataFilter(e.target.value));
  }
  function handleAvailedFilterChange(e) {
    console.log("e:", e);
    dispatch(setAvailedFilter(e.target.value));
  }

  const clearSelected = () => {
    dispatch(setSelectedMatched([]));
    dispatch(setSelectedProbable([]));
    dispatch(setSelectedMismatch([]));
    dispatch(setSelectedNotInPR([]));
    dispatch(setSelectedNotInGstn([]));
    dispatch(setSelectedRejected([]));
    dispatch(setSelectedRowMismatch([]));
    dispatch(setSelectedRowNotInGstn([]));
    dispatch(setSelectedRowProbable([]));
    dispatch(setSelectedRowMatched([]));
    dispatch(setSelectedRejected([]));
  };

  // METHODS for TABS

  const handleDownload = (type) => {
    if (!docViewTableData || docViewTableData.length === 0) {
      errorToastMessage("No data available to download");
      return;
    }
    if (
      defaultEntity &&
      selectedGstin?.length > 0 &&
      selection &&
      recoSelection &&
      selectedYear
    ) {
      dispatch(
        downloadExcelDocView(
          selectedGstin,
          selection,
          recoSelection,
          selectedYear,
          dateRange,
          activeTabReco,
          activeTabViewReco,
          activeTabDocView
        )
      );
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    dispatch(setSearchStr(value));
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSubmit(false, 1, value);
    }, 500);
  };
  const handleReset = async (selected,selectedRow) => {
    if (!selected || selected?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    await dispatch(getReset(selected,selectedRow));
    dispatch(setSelectedRejected([]));
     dispatch(setSelectedRowMatched([]));
    await handleSubmit(false, 1);
  };
  const handleAcceptPrGstn = async (selected, action, selectedRow) => {
    if (!selected || selected?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    await dispatch(getAcceptPrGstn(selected, action, selectedRow));
    clearSelected();
    // dispatch(setSelectedProbable([]));
    // dispatch(setSelectedMismatch([]));
    // dispatch(setSelectedNotInPR([]));
    // dispatch(setSelectedNotInGstn([]));
    // dispatch(setSelectedRejected([]));
    // dispatch(setSelectedRowMismatch([]));
    // dispatch(setSelectedRowNotInGstn([]));
    // dispatch(setSelectedRowProbable([]));
    await handleSubmit(false, 1);
  };
  // const handleAcceptGSTN = async(selected, action) => {
  //   if (!selected || selected?.length === 0) {
  //     return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
  //   }
  //  await dispatch(getAcceptGSTN(selected,action));
  // };
  const handlePending = async (selected, action, selectedRow) => {
    if (!selected || selected?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    await dispatch(getPending(selected, action, selectedRow));
    clearSelected();
    await handleSubmit(false, 1);
  };
  const handleDeLink = async (selected, selectedRow) => {
    if (!selected || selected?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    await dispatch(getDeLink(selected, selectedRow));
    dispatch(setSelectedProbable([]));
    dispatch(setSelectedMismatch([]));
    dispatch(setSelectedRowMismatch([]));
    dispatch(setSelectedRowProbable([]));
    handleSubmit(false, 1);
  };
  const handleReject = async (selected, action, selectedRow) => {
    if (!selected || selected?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    await dispatch(getReject(selected, action, selectedRow));
    clearSelected();
    await handleSubmit(false, 1);
  };

  // const handlePageClick = (value) => {
  //   if(activeTabDocView === "1"){
  //     dispatch(setPageNoMatched(value))
  //   }
  //   else if(activeTabDocView === "2"){
  //     dispatch(setPageNoMismatch(value))
  //   }
  //   // setPageNoProc(value.selected + 1);
  //   handleSubmit(false,value.selected + 1);
  // };
  const handlePageClick = (value) => {
    const tabDispatchMap = {
      1: setPageNoMatched,
      3: setPageNoMismatch,
      2: setPageNoProbable,
      5: setPageNoNotInGstn,
      4: setPageNoNotInPr,
      6: setPageNoRejected, // Add other tab handlers as needed
    };

    const action = tabDispatchMap[activeTabDocView];
    if (action) {
      dispatch(action(value.selected + 1));
    }

    handleSubmit(false, value.selected + 1);
  };

  const handleSubmit = async (msgFlag = true, pageNo, search = "") => {
    try {
      if (
        defaultEntity &&
        selectedGstin &&
        selectedGstin?.length > 0 &&
        selection &&
        recoSelection &&
        selectedYear  &&    
         (selection !== 'Document Date' || (dateRange && dateRange[0]?.startDate && dateRange[0]?.endDate))

      ) {
        await dispatch(
          getRecoTablesData(
            selectedGstin,
            selection,
            recoSelection,
            selectedYear,
            dateRangeFilter,
            activeTabReco,
            activeTabViewReco,
            activeTabDocView,
            pageNo,
            rgstinTaxpayerFilter,
            sgstinTaxpayerFilter,
            inumFilter,
            monthFilter,
            month3bFilter,
            baseDataFilter,
            availedFilter,
            search,
            msgFlag
          )
        );
        console.log('doc view handle submit')
        if(msgFlag === true)dispatch(setSearchStr(''));
      } else {
        console.log("Please enter all mandatory fields");
        if (msgFlag === true) {
          errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
        }
      }
    } catch (error) {
      console.log("Error in handleSubmit:", error);
    }
  };

  const clearFilter = () => {
    dispatch(setRgstinTaxpayerFilter([]));
    dispatch(setSgstinTaxpayerFilter([]));
    dispatch(setInumFilter([]));
    dispatch(setMonthFilter([]));
    dispatch(setMonth3bFilter([]));
    dispatch(setBaseDataFilter([]));
    dispatch(setAvailedFilter([]));
  };
  useEffect(() => {
     dispatch(setSearchStr(""));
    clearFilter();
    handleSubmit(false, 1);
    clearSelected();
   
  }, [activeTabDocView]);

  return (
    <>
      <div
        style={{
          display: "flex",
          height: "3em",
          boxShadow: "0px 2px 3px 0px #8080805e",
          paddingRight: "5px",
          marginTop: "0.6em",
        }}
      >
        <TableHeader
          handleTabChange={handleTabChange}
          columns={DocViewHeaders}
          activeTab={activeTabDocView}
        />
      </div>
      <div style={{ marginTop: "0.6em" }}>
        {activeTabDocView === "1" && (
          <Matched
            handleOpen={handleOpen}
            handleDownload={handleDownload}
            handleInputChange={handleInputChange}
            handlePageClick={handlePageClick}
            handleSubmit={handleSubmit}
          />
        )}
        {activeTabDocView === "2" && (
          <ProbableMatch
            handleOpen={handleOpen}
            handleDownload={handleDownload}
            handleInputChange={handleInputChange}
            handleAcceptPrGstn={handleAcceptPrGstn}
            handlePending={handlePending}
            handleDeLink={handleDeLink}
            handleReject={handleReject}
             handleSubmit={handleSubmit}
            handlePageClick={handlePageClick}
          />
        )}
        {activeTabDocView === "3" && (
          <MisMatch
            handleOpen={handleOpen}
            handleDownload={handleDownload}
            handleInputChange={handleInputChange}
            handleAcceptPrGstn={handleAcceptPrGstn}
            handlePending={handlePending}
            handleDeLink={handleDeLink}
            handleReject={handleReject}
            handlePageClick={handlePageClick}
             handleSubmit={handleSubmit}
          />
        )}
        {activeTabDocView === "4" && (
          <NotInPR
            handleOpen={handleOpen}
            handleDownload={handleDownload}
            handleInputChange={handleInputChange}
            handlePending={handlePending}
            handleReject={handleReject}
            handleAcceptPrGstn={handleAcceptPrGstn}
            handleReset={handleReset}
            handlePageClick={handlePageClick}
             handleSubmit={handleSubmit}
          />
        )}
        {activeTabDocView === "5" && (
          <NotInGSTN
            handleOpen={handleOpen}
            handleDownload={handleDownload}
            handleInputChange={handleInputChange}
            handlePending={handlePending}
            handlePageClick={handlePageClick}
          handleAcceptPrGstn={handleAcceptPrGstn}
           handleSubmit={handleSubmit}
          />
        )}
        {activeTabDocView === "6" && (
          <Rejected
            handleOpen={handleOpen}
            handleDownload={handleDownload}
            handleInputChange={handleInputChange}
            handleReset={handleReset}
            handlePageClick={handlePageClick}
             handleSubmit={handleSubmit}
          />
        )}
      </div>
      <Dialog
        className="filterModal"
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth={true}
        maxWidth="sm"
      >
        <div
          style={{
            position: "absolute",
            top: "6px",
            left: "-26px",
            cursor: "pointer",
          }}
           onClick={handleClearFilter}
        >
          <img src={filterImage} alt="fliter" width="100px" height="40px" />
          <span
            style={{
              position: "absolute",
              top: "8px",
              left: "36px",
              fontSize: "12px",
              color: "white",
            }}
          >
            Filters
          </span>
        </div>
        <DialogTitle
          id="alert-dialog-slide-title"
          style={{ display: "flex", justifyContent: "end" }}
        >
          <Button
            onClick={handleClearFilter}
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              padding: "5px 45px",
              fontSize: "10px",
              marginRight: "10px",
            }}
          >
            Clear Filters
          </Button>
          <Button
            onClick={handleFilterApply}
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              padding: "5px 45px",
              fontSize: "10px",
            }}
          >
            Apply Filters
          </Button>
        </DialogTitle>

        <DialogContent style={{ padding: "0px 8px", marginBottom: "1em" }}>
          {activeTabDocView === "1" && (
            <MatchedFilter
              // recipient gstin
              recipientGstin={recipientGstin}
              rgstinTaxpayerFilter={rgstinTaxpayerFilter}
              defaultPropsRecipientGstins={defaultPropsRecipientGstins}
              onChangeRecipientGstin={onChangeRecipientGstin}
              handleChipDelete={handleChipDelete}
              handleAddRecipientGstin={handleAddRecipientGstin}
              // supplier gstin
              supplierGstin={supplierGstin}
              sgstinTaxpayerFilter={sgstinTaxpayerFilter}
              defaultPropsSupplierGstins={defaultPropsSupplierGstins}
              onChangeSupplierGstin={onChangeSupplierGstin}
              handleAddSupplierGstin={handleAddSupplierGstin}
              // inum
              inumFilter={inumFilter}
              inum={inum}
              defaultPropsInum={defaultPropsInum}
              onChangeInum={onChangeInum}
              handleAddInum={handleAddInum}
              // matched month
              monthFilter={monthFilter}
              month={month}
              defaultPropsMonth={defaultPropsMonth}
              onChangeMonth={onChangeMonth}
              handleAddMonth={handleAddMonth}
              // matched month 3b
              month3bFilter={month3bFilter}
              month3b={month3b}
              defaultPropsMonth3b={defaultPropsMonth3b}
              onChangeMonth3b={onChangeMonth3b}
              handleAddMonth3b={handleAddMonth3b}
              // base data
              baseDataList={baseDataList}
              baseDataFilter={baseDataFilter}
              handleBaseDataFilterChange={handleBaseDataFilterChange}
              // availed
              availedList={availedList}
              availedFilter={availedFilter}
              handleAvailedFilterChange={handleAvailedFilterChange}
            />
          )}
          {activeTabDocView !== "1" && (
            <NotMatchedFilter
              // recipient gstin
              recipientGstin={recipientGstin}
              rgstinTaxpayerFilter={rgstinTaxpayerFilter}
              defaultPropsRecipientGstins={defaultPropsRecipientGstins}
              onChangeRecipientGstin={onChangeRecipientGstin}
              handleChipDelete={handleChipDelete}
              handleAddRecipientGstin={handleAddRecipientGstin}
              // supplier gstin
              supplierGstin={supplierGstin}
              sgstinTaxpayerFilter={sgstinTaxpayerFilter}
              defaultPropsSupplierGstins={defaultPropsSupplierGstins}
              onChangeSupplierGstin={onChangeSupplierGstin}
              handleAddSupplierGstin={handleAddSupplierGstin}
              // inum
              inumFilter={inumFilter}
              inum={inum}
              defaultPropsInum={defaultPropsInum}
              onChangeInum={onChangeInum}
              handleAddInum={handleAddInum}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DocView;
